import { WithStyles, withStyles } from '@mui/styles';
import { ClientMessageRecord } from '@tassat/payments-definitions';

import { ClientMessageContentDetails } from './clientMessageContentDetails';
import { muiStyles } from './styles';

export interface ClientMessageContentDetailsProps extends WithStyles<typeof muiStyles> {
    selectedMessage: ClientMessageRecord;
}

export default withStyles(muiStyles)(ClientMessageContentDetails);